import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {useTranslation} from 'react-i18next';
import ReactsCard from "../components/ui/ReactsCard";
import {useOrganization} from "../components/organizations/organization-context";
import {CrossOrganizationSearch} from "../components/_shared/CrossOrganizationSearch";
import {Button} from "@material-ui/core";
import {useNavigate} from "react-router-dom";
import {Machines} from "../components/machines/Machines";


const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 250,
        margin: theme.spacing(4)
    },
    action: {
        justifyContent: 'flex-end'
    },
    table: {
        marginTop: '2rem',
        display: 'flex',
        justifyContent: 'center'
    }
}));

const MachinesView = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [currentOrganization] = useOrganization();

    const moveMachine = () => {
        navigate('/machines/move?returnUrl=/machines');
    };


    return (
        <ReactsCard title={t('Machine.Title')} className={classes.root}>
            <div className={classes.table}>
                <CrossOrganizationSearch organization={currentOrganization}>
                    <CrossOrganizationSearch.Action>
                        <Button variant="contained"
                                color="primary"
                                size="medium"
                                onClick={moveMachine}>
                            {t('Machine.MoveMachines.Title')}
                        </Button>
                    </CrossOrganizationSearch.Action>
                    <CrossOrganizationSearch.Body>
                        <Machines/>
                    </CrossOrganizationSearch.Body>
                </CrossOrganizationSearch>
            </div>
        </ReactsCard>
    )
};

export default MachinesView;
